<div class="card-status p-3 d-flex flex-column rounded rounded-3">
    <div class="w-100 d-flex flex-column justify-content-start">
        <div class="d-flex flex-row justify-content-between">
            <p class="p-0 card-status-heading">Choose Status</p>
        </div>
    </div>

    <mat-card *ngFor="let statusItem of statusItems" class="mb-2 card-status-selection w-100 pointer shadow-none">
        <mat-card-content
            (click)="closeModal(statusItem.name)"
            [ngClass]="{
                status__active: statusItem.name === 'ACTIVE',
                status__suspended: statusItem.name === 'SUSPENDED',
            }"
            class="w-100 d-flex flex-row justify-content-start align-items-center"
        >
            <app-spinner [isLoading]="false" />
            <span class="card-status-selection-content status-circle fs-6"></span>
            <p class="m-0 p-0 mx-2 card-status-selection-content">{{ statusItem.value }}</p>
        </mat-card-content>
    </mat-card>
</div>
